import { css, GridCol, mixins, styled } from '@bob/library'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`

export type BackgroundBrickStyleProps = {
  backgroundColor?: string
  reversedLayout?: boolean
  paralaxOffset?: number
}
export const BackgroundBrick = styled(GridCol)<BackgroundBrickStyleProps>`
  position: relative;
  ${mixins.margin.top(100)};
  ${({ paralaxOffset }) =>
    css`
      transform: translate3D(0, ${paralaxOffset ?? 0}px, 0);
      transition-duration: 0.2s;
      transition-timing-function: ease;
    `}

  ${mixins.media.min.desktop} {
    ${({ backgroundColor, reversedLayout }) => css`
      &::before {
        content: '';
        position: absolute;
        top: 0;
        ${reversedLayout
          ? css`
              left: 0;
              transform: translate(-20%, -20%) scale(0.9);
            `
          : css`
              right: 0;
              transform: translateY(-20%) scale(0.9);
            `}
        z-index: -1;
        width: 100%;
        padding-bottom: 100%;
        background-color: ${backgroundColor};
      }
    `};
  }
`

export const Content = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  align-content: center;
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
  ${mixins.padding.bottom(25)};
  width: 100%;
  margin: auto;
  ${mixins.margin.left(0)};
`
export const Caption = styled.h5`
  width: 100%;
  ${mixins.typography.subtitleMedium};
  ${mixins.margin(0)};
`
export const Headline = styled.h1`
  width: 100%;
  ${mixins.typography.headlineLarge};
  ${mixins.margin.top(20)};
  ${mixins.margin.bottom(25)};
`
export const Description = styled.div`
  width: 100%;
  ${mixins.margin(25, 0)};

  & p {
    font-weight: 400;
    color: ${mixins.colors.grayDark};
    ${mixins.margin(0)};
  }
`

export const CTAWrapper = styled.div`
  width: 100%;
`

export type LearnMoreButtonWrapperProps = {
  isSibling?: boolean
}
export const LearnMoreButtonWrapper = styled.div<LearnMoreButtonWrapperProps>`
  ${({ isSibling }) => isSibling && mixins.margin.top(15)}
`
